export default __webpack_public_path__ + "static/media/tempStore2.495d6e98.png";